module.exports = __webpack_public_path__ + "img/4.694cc850.jpg";